import { render, staticRenderFns } from "./LanguagePreview.vue?vue&type=template&id=10641ddf&"
import script from "./LanguagePreview.vue?vue&type=script&lang=js&"
export * from "./LanguagePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports